import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { AppInitializationService } from 'app/app-initialization.service';
import { DriverProcess } from 'app/models/driverProcess.model';
import { User } from 'app/models/user.model';
import { DriverProcessService } from 'app/services/driver-process.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DriverProcessDetailComponent } from './driver-process-detail/driver-process-detail.component';
import { GenericMapComponent } from '../../generic-map/generic-map.component';
import { CompanyService } from 'app/services/company.service';
import { CustomFuelInformation } from 'app/models/custom-fuel-information.model';
import { RouteHistoryComponent } from './route-history/route-history.component';

@Component({
    selector: 'driver-process',
    templateUrl: './driver-process.component.html',
    styleUrls: ['./driver-process.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class DriverProcessComponent implements OnInit {
    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    private _driverProcessList: Array<DriverProcess> = [];
    public get driverProcessList(): Array<DriverProcess> {
        return this._driverProcessList;
    }

    public isShift = true;
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }

    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }

    private _dataSource: MatTableDataSource<DriverProcess> = undefined;
    public get dataSource(): MatTableDataSource<DriverProcess> {
        return this._dataSource;
    }

    private _displayedColumns = ['polygon', 'plate', 'allContainerCount', 'fullContainerCount', 'emptyContainerCount', 'estimatedDistance', 'estimatedTime', 'description', 'startDate', 'endDate', 'setting'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _driverProcessService: DriverProcessService,
        private appConfigService: AppInitializationService,
        private _spinner: NgxSpinnerService,
        private _dialog: MatDialog
    ) { }

    async ngOnInit() {
        var isShift = this.appConfigService.apiConfig["isShift"]
        this.isShift = isShift;

        if (isShift) {
            this._displayedColumns = ['polygon', 'driver_name', 'plate', 'allContainerCount', 'fullContainerCount', 'emptyContainerCount', 'estimatedDistance', 'estimatedTime', 'distanceTraveled', 'profitability', 'description', 'startLocation', 'startDate', 'endLocation', 'endDate', 'setting']
        }
        else {
            this._displayedColumns = ['polygon', 'driver_name', 'plate', 'allContainerCount', 'fullContainerCount', 'emptyContainerCount', 'estimatedDistance', 'estimatedTime', 'distanceTraveled', 'profitability', 'startLocation', 'startDate', 'endLocation', 'endDate', 'setting']
        }

        await this.getDriverProcessList();
        this.updateTableDataSource();
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'plate': return item.car.plate;
                case 'description': return item.shift ? item.shift.description : null;
                default: return item[property];
            }
        }
    }

    private async getDriverProcessList(): Promise<Array<DriverProcess>> {
        try {
            this._spinner.show('loading');
            this._driverProcessList = await this._driverProcessService.getDriverProcess(parseInt(localStorage.getItem("CompanyID")));

            this._spinner.hide('loading')
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);
            return [];
        }
        await this.updateTableDataSource();
    }

    async deleteProcessDelete(driverProcess: DriverProcess) {
        try {
            this._driverProcessService.delete(driverProcess);
            await this.refresh();
        } catch (error) {
            this._spinner.hide('loading')
            console.warn(error);

        }
        await this.refresh();
    }
    async refresh() {
        await this.getDriverProcessList();
    }

    public async onDriverProcessStartMap(element: DriverProcess) {
        const dialog = this._dialog.open(GenericMapComponent, {
        })
        dialog.componentInstance.latitude = parseFloat(element.startLat);
        dialog.componentInstance.longitude = parseFloat(element.startLng);
    }

    public async onDriverProcessEndMap(element: DriverProcess) {
        const dialog = this._dialog.open(GenericMapComponent, {
        })
        dialog.componentInstance.latitude = parseFloat(element.endLat);
        dialog.componentInstance.longitude = parseFloat(element.endLng);
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<DriverProcess>(this._driverProcessList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public driverProcessDetail(driverProcess: DriverProcess) {
        this._dialog.open(DriverProcessDetailComponent,
            {
                data: driverProcess,
                disableClose: false,

            })
    }

    public routeHistory(driverProcess: DriverProcess) {
        const dialog = this._dialog.open(RouteHistoryComponent,
            {
                data: driverProcess,
                disableClose: false,
            })
        dialog.componentInstance.driverProcessId=driverProcess.id;
    }
}
